import { ApiFunc, getInstance } from '@helpers/httpClient'

import * as API from '../constants/api'

const instance = getInstance()

export const logsAssessmentAudit: ApiFunc<`${typeof API.LOGS_ASSESSMENT_AUDIT}`, 'get'> = data =>
  instance.get(API.LOGS_ASSESSMENT_AUDIT, {
    params: data,
  })

export const logsAssessmentStudentList: ApiFunc<`${typeof API.LOGS_ASSESSMENT_STUDENT_LIST}`, 'get'> = data =>
  instance.get(API.LOGS_ASSESSMENT_STUDENT_LIST, {
    params: data,
  })

export const logsAssessmentStudentSubmissions: ApiFunc<
  `${typeof API.LOGS_ASSESSMENT_STUDENT_SUBMISSIONS}`,
  'get'
> = data =>
  instance.get(API.LOGS_ASSESSMENT_STUDENT_SUBMISSIONS, {
    params: data,
  })
